<template>
  <div class="d-flex rounded-circle align-items-center">
    <div
      class="rounded-circle bg-light border m-auto"
      style="width: 50%; height: 50%"
    />
  </div>
</template>

<script>
export default {
  name: 'BSlideColtroller',
}
</script>
